import PropTypes from 'prop-types';
import {UserResource} from "./user-resource";

export const ElectionResource = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    body: PropTypes.string.isRequired,
    candidate: PropTypes.shape(UserResource),
    current_level: PropTypes.number.isRequired,
    status: PropTypes.string.isRequired,
};
